import { render, staticRenderFns } from "./filters.component.vue?vue&type=template&id=2248c03b&scoped=true&"
import script from "./filters.component.vue?vue&type=script&lang=js&"
export * from "./filters.component.vue?vue&type=script&lang=js&"
import style0 from "./filters.component.vue?vue&type=style&index=0&id=2248c03b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2248c03b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2248c03b')) {
      api.createRecord('2248c03b', component.options)
    } else {
      api.reload('2248c03b', component.options)
    }
    module.hot.accept("./filters.component.vue?vue&type=template&id=2248c03b&scoped=true&", function () {
      api.rerender('2248c03b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/filters.component.vue"
export default component.exports